import { render, staticRenderFns } from "./FormCreateAttachment.vue?vue&type=template&id=4a1e7b71&"
import script from "./FormCreateAttachment.vue?vue&type=script&lang=js&"
export * from "./FormCreateAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports